import { useContext } from 'react';
import { CalendarContext } from '@/components/calendar/context';

export default function useCalendarContext() {
  const context = useContext(CalendarContext);
  if (!context) throw new Error('useCalendarContext must be used within a context');
  return context;
}
